const CATALOGOS = {
    audiencias: [
        { llave: 1, valor: "Es Audiencia" },
        { llave: 0, valor: "Es Evento" }
    ],
    partidoJudicial: [
        { llave: "1", valor: "1 - Aguascalientes" },
        { llave: "2", valor: "2 - Calvillo" },
        { llave: "3", valor: "3 - Pabellón" },
        { llave: "4", valor: "4 - Rincón de Romos" },
        { llave: "5", valor: "5 - Jesús María" },
        { llave: "6", valor: "6 - Adolescentes" },
    ],
    tiposSalas: [
        { llave: "1", valor: "1" },
        { llave: "2", valor: "2" },
        { llave: "3", valor: "3" },
        { llave: "4", valor: "4" },
        { llave: "5", valor: "5" },
        { llave: "6", valor: "6" },
        { llave: "7", valor: "7" },
        { llave: "8", valor: "8" },
        { llave: "9", valor: "9" },
        { llave: "10", valor: "10" },
        /*{ llave: "Virt", valor: "Virt" },
        { llave: "11", valor: "11" },
        { llave: "12", valor: "12" },
        { llave: "13", valor: "13" },
        { llave: "14", valor: "14" },*/
        { llave: "1 Ejec", valor: "1 Ejec" },
        { llave: "2 Ejec", valor: "2 Ejec" },
        { llave: "Cab 1", valor: "Cab 1" },
        { llave: "Cab 2", valor: "Cab 2" },
        { llave: "Cab 3", valor: "Cab 3" },
        { llave: "Cab 4", valor: "Cab 4" },
        { llave: "Cab 5", valor: "Cab 5" },
        { llave: "Cab 6", valor: "Cab 6" },
        { llave: "Cab 7", valor: "Cab 7" },
        { llave: "Cab 8", valor: "Cab 8" },
        { llave: "Cab 9", valor: "Cab 9" },
        { llave: "Cab 10", valor: "Cab 10" },
        { llave: "Cab 11", valor: "Cab 11" },
        { llave: "Cab 12", valor: "Cab 12" },
        { llave: "Loc 1", valor: "Loc 1" },
        { llave: "Loc 2", valor: "Loc 2" },
        { llave: "Loc 3", valor: "Loc 3" },
        { llave: "Loc 4", valor: "Loc 4" },
        { llave: "Loc 5", valor: "Loc 5" },
        { llave: "Loc 6", valor: "Loc 6" },
        { llave: "Loc 7", valor: "Loc 7" },
        { llave: "Loc 8", valor: "Loc 8" },
        { llave: "Loc 9", valor: "Loc 9" },
        { llave: "Loc 10", valor: "Loc 10" },
        // { llave: "1", valor: "1" },
        // { llave: "2", valor: "2" },
        // { llave: "3", valor: "3" },
        // { llave: "4", valor: "4" },
        // { llave: "5", valor: "5" },
        // { llave: "6", valor: "6" },
        // { llave: "7", valor: "7" },
        // { llave: "8", valor: "8" },
        // { llave: "9", valor: "9" },
        // { llave: "10", valor: "10" },
        // { llave: "1 Ejec", valor: "1 Ejec" },
        // { llave: "2 Ejec", valor: "2 Ejec" }
    ],
    tiposAudiencias: [
        { llave: "Audiencia Inicial", valor: "ini audiencia inicial" },
        { llave: "Audiencia Intermedia", valor: "int audiencia intermedia" },
        { llave: "Audiencia de Juicio Oral", valor: "ajo audiencia de juicio oral" },
        { llave: "Continuación de Audiencia de Juicio Oral", valor: "cajo continuación de audiencia de juicio oral" },
        { llave: "Audiencia de Suspensión Condicional del Proceso", valor: "scp audiencia de suspensión condicional del proceso "},
        { llave: "Audiencia de Revisión de Suspensión Condicional del Proceso", valor: "rscp audiencia de revisión de suspensión condicional del proceso" },
        { llave: "Audiencia Revisión de Medidas Cautelares", valor: "mc audiencia de revisión de medidas cautelares" },
        { llave: "Audiencia de Ratificación de Medidas de Protección", valor: "mp audiencia de ratificación de medidas de protección" },
        { llave: "Audiencia de Procedimiento Abreviado", valor: "pa audiencia de procedimiento abreviado" },
        { llave: "Audiencia de Acuerdo Reparatorio", valor: "ar audiencia de acuerdo reparatorio" },
        { llave: "Audiencia de Revisión de Acuerdo Reparatorio", valor: "rvar audiencia de revisión de acuerdo reparatorio" },
        { llave: "Audiencia de Ratificación de Acuerdo Reparatorio", valor: "rar audiencia de ratificación de acuerdo reparatorio" },
        { llave: "Audiencia de Modificación de Acuerdo Reparatorio", valor: "mar audiencia de modificación de acuerdo reparatorio" },
        { llave: "Continuación de Audiencia Inicial", valor: "cini audiencia de continuación de audiencia inicial" },
        { llave: "Audiencia de Lectura y Explicación de Sentencia", valor: "les audiencia de lectura y explicación de sentencia" },
        { llave: "Audiencia de Emisión de Fallo", valor: "ef audiencia de emisión de fallo" },
        { llave: "Audiencia de Individualización de Sanciones", valor: "ind audiencia de individualización de sanciones" },
        { llave: "Audiencia de Segunda Instancia", valor: "seg audiencia de segunda instancia" },
        { llave: "Audiencia Vía Telefónica ", valor: "cat audiencia de orden de cateo" },
        { llave: "Audiencia Vía Telefónica", valor: "audiencia de orden de aprehensión" },
        { llave: "Audiencia Vía Telefónica  ", valor: "tel audiencia vía telefónica" },
        { llave: "Audiencia de Carpeta Administrativa", valor: "ca audiencia de carpeta administrativa" },
        { llave: "Audiencia de Carpeta Digital", valor: "cd audiencia de carpeta digital" },
        { llave: "Audiencia de Técnica de Investigación", valor: "tec audiencia de técnica de investigación" },
        { llave: "Audiencia de Ratificación de Ingreso a Domicilio", valor: "rid audiencia de ratificación de ingreso a domicilio" },
        { llave: "Audiencia de Prórroga de Plazo de Investigación Complementaria", valor: "pic audiencia de prórroga de plazo de investigación complementaria" },
        { llave: "-", valor: "-" },
        { llave: "Audiencia de Otorgamiento de Perdón", valor: "audiencia de otorgamiento de perdon" },
        { llave: "Audiencia de Ratificación de Perdón", valor: "audiencia de ratificacion de perdon" },
        { llave: "Audiencia de Ratificación de Datos Conservados", valor: "rdc audiencia de ratificacion de datos conservados" },
        { llave: "Audiencia de Tutela de Derechos", valor: "td audiencia de tutela de derechos" },
        { llave: "Audiencia de Tutela de Garantías", valor: "tg audiencia de tutela de garantías" },
        { llave: "Audiencia diversa", valor: "audiencia diversa - otro tipo de audiencia" },                    
        { llave: "Audiencia de Sobreseimiento", valor: "audiencia de sobreseimiento" },
        { llave: "Sesión de Mediación", valor: "med alt sesión de mediación de justicia alternativa" },                 
        { llave: "Bloqueo Temporal de Día - Probable Participación en Juicio", valor: "bloqueo temporal por pobable participación en juicio oral" },
        { llave: "Bloqueo Temporal de 8 a 10 horas - Probable Reunión Magistrada", valor: "bloqueo temporal por pobable reunión" }
    ],
    tiposModo: [ 
        /* { llave: 'Presencial', valor: 'Pres.' }, 
        { llave: 'Video', valor: 'Vid' }, */
        { llave: 'Pres.', valor: 'Pres.' },
        { llave: 'Zoom', valor: 'Zoom' },
        { llave: 'Tel.', valor: 'Tel.' }
    ],
    tiposZoom: [ 
        { llave: '655 358 1024', valor: 'Aristóteles - 655 358 1024' },
        { llave: '974 952 1697', valor: 'Antonio Laris - 974 952 1697' },
        { llave: '774 667 7937', valor: 'Daniel - 774 667 7937' },
        { llave: '339 408 6206', valor: 'Bedoy - 339 408 6206'},
        // { llave: '974 952 1697', valor: 'Bermúdez - 974 952 1697'},
        { llave: '285 124 0715', valor: 'Cristi - 285 124 0715' },
        { llave: '292 168 3662', valor: 'Diana - 292 168 3662' },
        { llave: '388 423 2719', valor: 'Disa - 388 423 2719' },
        { llave: '959 797 9085', valor: 'Felipe - 959 797 9085' },
        { llave: '745 616 5805', valor: 'Joaquín - 745 616 5805' },
        { llave: '322 917 1534', valor: 'Joselin - 322 917 1534' },
        { llave: '448 594 3585', valor: 'Armando - 448 594 3585' },
        { llave: '857 888 9489', valor: 'Margarita - 857 888 9489'},
        { llave: '755 939 0820', valor: 'Méndez - 755 939 0820' },
        { llave: '906 253 9822', valor: 'Quiroz - 906 253 9822' },
        { llave: '531 821 4147', valor: 'Lozano - 531 821 4147' },
        { llave: '582 082 4538', valor: 'Lucía - 582 082 4538'},
        { llave: '374 969 0432', valor: 'Luz - 374 969 0432' },
        { llave: '321 690 2242', valor: 'Ruiz - 321 690 2242' },
        { llave: '437 398 3203', valor: 'Yuri - 437 398 3203' },
        { llave: '971 115 0960', valor: 'Rogelio - 971 115 0960' },
      
     ],
    tiposDetenido: [ 
        { llave: 0, valor: 'sd Sin detenido' }, 
        { llave: 1, valor: 'cd Con detenido' }
    ],
    tiposDetenidoAbreviado: [ 
        { llave: 0, valor: 'SD' }, 
        { llave: 1, valor: 'CD' }
    ],
    tiposAxiliar: [
        //{ llave: 'Abril', valor: 'Abril' }, 
        { llave: 'Alonso', valor: 'Alonso' },
        { llave: 'Ana Acosta', valor: 'Ana Acosta' },
        { llave: 'Ana Paula', valor: 'Ana Paula' },
        { llave: 'Angel', valor: 'Ángel' },
        { llave: 'Anya', valor: 'Ánya' },
        { llave: 'Aranza', valor: 'Aranza' },
        { llave: 'Aux. Guardia', valor: 'Aux. Guardia' },
        { llave: 'Carlos', valor: 'Carlos' },
        { llave: 'Claudia', valor: 'Claudia' },
        //{ llave: 'Claudia', valor: 'Claudia' },
        /* { llave: 'Emiliano', valor: 'Emiliano' }, */
        { llave: 'Dulce', valor: 'Dulce' },
        //{ llave: 'Felipe', valor: 'Felipe' },
        { llave: 'Fernando', valor: 'Fernando' },
        // { llave: 'Hector', valor: 'Hector' },
        /* { llave: 'Laura G', valor: 'Laura G' }, */
        /* { llave: 'Liz', valor: 'Liz' },  */
        { llave: 'Israel', valor: 'Israel' },
        { llave: 'Jaqueline', valor: 'Jaqueline' },  
        { llave: 'Jehovana', valor: 'Jehovana' },
        { llave: 'Jessy Ramirez', valor: 'Jessy Ramirez' },
        { llave: 'José Manuel', valor: 'José Manuel' },     
        // { llave: 'Jorge A.', valor: 'Jorge A.' },
        { llave: 'Juan Pablo', valor: 'Juan Pablo' },
        //{ llave: 'JUANA MARIA', valor: 'JUANA MARIA' },
        // { llave: 'Jorge Ricardo', valor: 'Jorge Ricardo' },
        /* { llave: 'Julieta', valor: 'Julieta' }, */
        /* { llave: 'Juan Pablo', valor: 'Juan Pablo' }, */
        // { llave: 'Mane', valor: 'Mane' },
       // { llave: 'Monserrat', valor: 'Monserrat' },
        //  { llave: 'Moy', valor: 'Moy' },
        { llave: 'Mane', valor: 'Mane' },
        { llave: 'Monica', valor: 'Monica' },
        { llave: 'Nancy', valor: 'Nancy' },
        { llave: 'Nestor', valor: 'Nestor' },
        { llave: 'Noemí', valor: 'Noemí' },
        /* { llave: 'Nidya', valor: 'Nidya' }, */
        // { llave: 'Oscar', valor: 'Oscar' },
        // { llave: 'Paulina', valor: 'Paulina' },
        { llave: 'Sandra', valor: 'Sandra' },
        //{ llave: 'Sarah', valor: 'Sarah' },
       
       // { llave: 'Andrea', valor: 'Andrea' },
        { llave: 'Sofia', valor: 'Sofia' },
        { llave: 'Víctor', valor: 'Víctor' },
     
        // { llave: 'Ximena', valor: 'Ximena' },
        //{ llave: 'Estefania', valor: 'Estefania' },
        
      

       
        // { llave: 'Jaqueline', valor: 'Jaqueline' },
        //{ llave: 'Abril', valor: 'Abril' },
        // { llave: 'Sandra', valor: 'Sandra' },
        { llave: 'Olympia', valor: 'Olympia' },
        /* { llave: 'Julia', valor: 'Julia' }, */
        { llave: 'Rogelio', valor: 'Rogelio' },
        { llave: 'Liz Rangel', valor: 'Liz Rangel' },
        { llave: 'Jessy Ramirez', valor: 'Jessy Ramirez' },
        { llave: 'Dustin', valor: 'Dustin' },
        { llave: 'Victor Rosales', valor: 'Victor Rosales' },
        /* { llave: 'Liz Barrón', valor: 'Liz Barrón' }, */
        /* { llave: 'Rosalba', valor: 'Rosalba' }, */
        /* { llave: 'Anahí', valor: 'Anahí' }, */
        // { llave: 'Alejandra', valor: 'Alejandra' },
        



        
  
        
      /*  { llave: 'J Luis', valor: 'J Luis' }, */
       /* { llave: 'Diego', valor: 'Diego' }, */
       /* { llave: 'Alejandro', valor: 'Alejandro' },*/
       /* { llave: 'Mariela', valor: 'Mariela' }, */
       /* { llave: 'Ãƒâ€œscar', valor: 'Óscar' },*/
       /* { llave: 'Edna', valor: 'Edna' }, */
       /* { llave: 'Diana L', valor: 'Diana L' },*/
       
       
     
     
        /*{ llave: 'Mario', valor: 'Mario' }, */
       
       /* { llave: 'Diana', valor: 'Diana' },
        { llave: 'Carlos', valor: 'Carlos' },
        { llave: 'Monica', valor: 'Monica' }, 
        { llave: 'Jorge Luis', valor: 'Jorge Luis' },*/
       
        /*{ llave: 'Dennis', valor: 'Dennis' },
        { llave: 'Axel', valor: 'Axel' }, 
        { llave: 'Ximena', valor: 'Ximena' },*/
     
       /* { llave: 'Brenda', valor: 'Brenda' },
        { llave: 'Pamela', valor: 'Pamela' }, 
        { llave: 'Karla', valor: 'Karla' },*/
      
        // { llave: 'Eduardo', valor: 'Eduardo' },
       /* { llave: 'Elizabeth', valor: 'Elizabeth' }, */
     
       /*  { llave: 'AimeÃƒÂ©', valor: 'AimeÃƒÂ©' },  */
       /* { llave: 'Liz', valor: 'Liz' },
        { llave: 'Denisse', valor: 'Denisse' }, 
        { llave: 'Jessica', valor: 'Jessica' },
        { llave: 'Gabriela', valor: 'Gabriela' }, */
        // { llave: 'Yaz', valor: 'Yaz' },
   
     
       /* { llave: 'Miguel', valor: 'Miguel' }, 
        { llave: 'ÃƒÂngeles', valor: 'Ángeles' },
        { llave: 'Diana Laura', valor: 'Diana Laura' }, 
        { llave: 'Israel', valor: 'Israel' },
        { llave: 'Williams', valor: 'Williams' }, 
        { llave: 'Jocelin', valor: 'Jocelin' },
        { llave: 'Laura', valor: 'Laura' }, */
   
      /*  { llave: 'NoemÃ­', valor: 'Noemí­' }, 
        { llave: 'Karen', valor: 'Karen' },
        { llave: 'Moni', valor: 'Moni' }, 
        { llave: 'Dulce', valor: 'Dulce' },
        { llave: 'Patricia', valor: 'Patricia' }, */
      
       /* { llave: 'Oscar', valor: 'Oscar' }, 
        { llave: 'Andrea', valor: 'Andrea' },
        { llave: 'Orlando', valor: 'Orlando' }, */
       
        // { llave: 'MoisÃƒÂ©s', valor: 'Moisés' }, 
     
        // { llave: 'Aux. Vesp.', valor: 'Aux. Vesp.' },
       /* { llave: 'Almendra', valor: 'Almendra' },
        { llave: 'ALEX', valor: 'ALEX' },
        { llave: 'Arturo', valor: 'Arturo' },
        { llave: 'Mayra', valor: 'Mayra' },*/
        // { llave: 'Fernanda', valor: 'Fernanda' },
       /* { llave: 'Carolina', valor: 'Carolina' },
        { llave: 'Mane', valor: 'Mane' },
        { llave: 'SOPHIA KARELY GONZÁLEZ PÉREZ', valor: 'SOPHIA KARELY' }*/
    ],
    tiposJuez: [ 
        { llave: 'Lic. Alfredo Quiroz García', valor: 'AQG Alfredo Quiroz García' },
        { llave: 'Lic. Antonio Laris Ornelas', valor: 'ALO Antonio Laris Ornelas' },
        { llave: 'Lic. Aristóteles González Velázquez', valor: 'AAGV Aristóteles González Velázquez' },
        { llave: 'Lic. Armando Reyes Medina', valor: 'ARM Armando Reyes Medina' },
        { llave: 'Lic. Cristina López Velarde', valor: 'ECLV Cristina López Velarde' },
        { llave: 'Lic. Diana Torres Jiménez', valor: 'DCTJ Diana Torres Jiménez' },
        { llave: 'Lic. Disaithram González Rodríguez', valor: 'DGR Disaithram González Rodríguez' },
        { llave: 'Lic. Eduardo Méndez Martínez', valor: 'JEMM Eduardo Méndez Martínez' },
        { llave: 'Lic. Felipe Chávez Gutiérrez', valor: 'FJCG Felipe Chávez Gutiérrez' },
        { llave: 'Lic. Francisco Lozano Herrera', valor: 'FLH Francisco Lozano Herrera' },
        { llave: 'Lic. Joaquín Rodrigo Valdez Durán', valor: 'JOA Joaquín Rodrigo Valdez Durán' },
        /* { llave: 'Lic. Josseline Jimena López Espinoza', valor: 'JJLE Josseline Jimena López Espinoza' }, */
        { llave: 'Lic. Fernando González Femat', valor: 'FGF Fernando González Femat' },

        { llave: 'Lic. Lourdes Cervantes Bedoy', valor: 'MLCB Lourdes Cervantes Bedoy' },
        { llave: 'Lic. Luis Daniel García Zepeda', valor: 'LDGZ Luis Daniel García Zepeda' },
       // { llave: 'Lic. Ma. de Lourdes Bermúdez', valor: 'MLB Ma. de Lourdes Bermúdez' },
        { llave: 'Lic. Margarita Estrada Peña', valor: 'MEP Margarita Estrada Peña' },

        { llave: 'Lic. María de la Luz Castro Palos', valor: 'MLCP María de la Luz Castro Palos' },

        { llave: 'Lic. María de Lourdes Ruiz Guerrero', valor: 'LRG María de Lourdes Ruiz Guerrero' },
        { llave: 'Lic. Omar Gabriel Delgado Macías', valor: 'OGDM Omar Gabriel Delgado Macías' },
        //{ llave: 'Lic. Rogelio Hernández Luévano', valor: 'RHL Rogelio Hernández Luévano' },
        { llave: 'Lic. Yuri Berthaud Reyes', valor: 'YBR Yuri Berthaud Reyes' },
        { llave: 'Lic. Lucía Anaid García Juárez', valor: 'LAGJ Lucía Anaid García Juárez' },
        { llave: 'Lic. Rogelio Hernández Luevano', valor: 'RHL Rogelio Hernández Luevano' },
           
        { llave: 'Juez 1', valor: 'J1 Juez 1' }, 
        { llave: 'Juez 2', valor: 'J2 Juez 2' }, 
        { llave: 'Juez 3', valor: 'J3 Juez 3' },     
        { llave: 'SP', valor: 'SP SEGUNDO PENAL' },       
        { llave: 'Todos', valor: 'TODX' }
    ],

    juecesConsultas: [ 
        { llave: 'Lic. Alfredo Quiroz García', valor: 'Alfredo Quiroz García' },
        { llave: 'Lic. Antonio Laris Ornelas', valor: 'Antonio Laris Ornelas' },
        { llave: 'Lic. Aristóteles González Velázquez', valor: 'Aristóteles González Velázquez' },
        { llave: 'Lic. Armando Reyes Medina', valor: 'Armando Reyes Medina' },
        { llave: 'Lic. Cristina López Velarde', valor: 'Cristina López Velarde' },
        { llave: 'Lic. Diana Torres Jiménez', valor: 'Diana Torres Jiménez' },
        { llave: 'Lic. Disaithram González Rodríguez', valor: 'Disaithram González Rodríguez' },
        { llave: 'Lic. Eduardo Méndez Martínez', valor: 'Eduardo Méndez Martínez' },
        { llave: 'Lic. Felipe Chávez Gutiérrez', valor: 'Felipe Chávez Gutiérrez' },
        { llave: 'Lic. Francisco Lozano Herrera', valor: 'Francisco Lozano Herrera' },
        //{ llave: 'Lic. Jesús Salas Herrada', valor: 'Jesús Salas Herrada' },
        { llave: 'Lic. Joaquín Rodrigo Valdez Durán', valor: 'Joaquín Rodrigo Valdez Durán' },
        /* { llave: 'Lic. Josseline Jimena López Espinoza', valor: 'Josseline Jimena López Espinoza' }, */
        { llave: 'Lic. Fernando González Femat', valor: 'Fernando González Femat' },

        { llave: 'Lic. Lourdes Cervantes Bedoy', valor: 'Lourdes Cervantes Bedoy' },
        { llave: 'Lic. Luis Daniel García Zepeda', valor: 'Luis Daniel García Zepeda' },
        //{ llave: 'Lic. Ma. de Lourdes Bermúdez', valor: 'Ma. de Lourdes Bermúdez' },
        { llave: 'Lic. Margarita Estrada Peña', valor: 'Margarita Estrada Peña' },

        { llave: 'Lic. María de la Luz Castro Palos', valor: 'María de la Luz Castro Palos' },
        { llave: 'Lic. María de Lourdes Ruiz Guerrero', valor: 'María de Lourdes Ruiz Guerrero' },
        //{ llave: 'Lic. María Guadalupe Rodríguez Martínez', valor: 'María Guadalupe Rodríguez Martínez' },
        { llave: 'Lic. Omar Gabriel Delgado Macías', valor: 'Omar Gabriel Delgado Macías' },
        //{ llave: 'Lic. Rogelio Hernández Luévano', valor: 'Rogelio Hernández Luévano' },
        { llave: 'Lic. Yuri Berthaud Reyes', valor: 'Yuri Berthaud Reyes' },
        { llave: 'Lic. Lucía Anaid García Juárez', valor: 'Lucía Anaid García Juárez' },
        { llave: 'Lic. Rogelio Hernández Luevano', valor: 'Rogelio Hernández Luevano' },
        { llave: 'Juez 1', valor: 'Juez 1' }, 
        { llave: 'Juez 2', valor: 'Juez 2' }, 
        { llave: 'Juez 3', valor: 'Juez 3' },
        { llave: 'SP', valor: 'SP SEGUNDO PENAL' }, 
        { llave: 'Todos', valor: 'TODX' }
    ],


    tiposPantalla: [ { llave: '0', valor: 'Oculta' }, { llave: '1', valor: 'Visible' } ],
    tiposEstado: [ 
        /* { llave: 'Iniciada', valor: 'Iniciada' }, 
        { llave: 'Pasar a sala', valor: 'Pasar a sala' }  */
        { llave: 'Próxima a iniciar', valor: 'Próxima a iniciar' },
        { llave: 'Pasar a sala', valor: 'Pasar a sala' },
        { llave: 'Iniciada', valor: 'Iniciada' },
        { llave: 'Concluida', valor: 'Concluida' },
        { llave: 'En receso', valor: 'En receso' },
        { llave: 'Diferida', valor: 'Diferida' }
    ],

    tiposCarpetas:[
        {llave:1,valor:'CD '},
        {llave:2,valor:'CA '},
        {llave:5,valor:'CJ '}
    ]
}

export { CATALOGOS };


// WEBPACK FOOTER //
// ./src/components/Audiencias/Catalogos/CatalogosBD.js